module.exports = __webpack_public_path__ + "static/media/image_xiao_bg.fbc4b2e5.png";